// extracted by mini-css-extract-plugin
module.exports = {"trans-color":"radio-button--trans-color","component":"radio-button--component","outer":"radio-button--outer","off":"radio-button--off","inner":"radio-button--inner"};